module.exports = __webpack_public_path__ + "img/20200613_093720.c5d118da.jpg";